const label = 'fill-slate-500 font-mono'

/** Static line drawing of the CADable flow: photo with callouts → 3D part → files. */
export default function CadableFlow() {
  return (
    <svg viewBox="0 0 360 150" className="h-auto w-full" fill="none" role="img"
      aria-label="CADable flow: a photo with measurement callouts becomes a 3D part and STEP, STL and G-code files">
      <text x="6" y="12" fontSize="7" letterSpacing="1.5" className={label}>PHOTO</text>
      <rect x="6" y="20" width="104" height="96" stroke="#475569" />
      <rect x="24" y="40" width="68" height="48" rx="3" stroke="#94a3b8" />
      <rect x="38" y="52" width="40" height="18" stroke="#22d3ee" strokeDasharray="3 2" opacity="0.7" />
      {[[31, 47], [85, 47], [31, 81], [85, 81]].map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="3" stroke="#22d3ee" strokeDasharray="2 1.5" opacity="0.7" />
      ))}
      <line x1="24" y1="100" x2="92" y2="100" stroke="#fbbf24" strokeWidth="1.5" />
      <line x1="24" y1="96" x2="24" y2="104" stroke="#fbbf24" />
      <line x1="92" y1="96" x2="92" y2="104" stroke="#fbbf24" />
      <text x="58" y="112" textAnchor="middle" fontSize="7" className="fill-amber-300 font-mono">68.0</text>

      <path d="M118 68 H140 M134 63 L140 68 L134 73" stroke="#22d3ee" />

      <text x="150" y="12" fontSize="7" letterSpacing="1.5" className={label}>3D PART</text>
      <polygon points="156,62 206,44 256,62 206,80" stroke="#94a3b8" />
      <polygon points="156,62 156,86 206,104 206,80" stroke="#94a3b8" />
      <polygon points="206,80 206,104 256,86 256,62" stroke="#94a3b8" />
      <polygon points="180,62 206,53 232,62 206,71" stroke="#22d3ee" opacity="0.8" />
      {[[168, 62], [206, 48], [244, 62], [206, 76]].map(([cx, cy]) => (
        <ellipse key={`${cx}-${cy}`} cx={cx} cy={cy} rx="3" ry="1.6" stroke="#22d3ee" opacity="0.8" />
      ))}

      <path d="M264 68 H286 M280 63 L286 68 L280 73" stroke="#22d3ee" />

      <text x="296" y="12" fontSize="7" letterSpacing="1.5" className={label}>FILES</text>
      {['STEP', 'STL', 'G-CODE'].map((f, i) => (
        <g key={f}>
          <rect x="296" y={30 + i * 30} width="58" height="20" stroke="#475569" />
          <text x="325" y={43 + i * 30} textAnchor="middle" fontSize="7.5" letterSpacing="1" className="fill-cyan-400 font-mono">{f}</text>
        </g>
      ))}
    </svg>
  )
}
